let host = process.env.VUE_APP_BACKEND_HOST;
/**
 * схема для аутентификации
 * @property {string} urlLogin - маршрут для login
 * @property {string} urlCheckPhone - проверка телефона
 * @property {string} urlLoginSms - авторизация через смс код
 * @property {string} urlLogout - маршрут для logout
 * @property {string} urlCheckToken - маршрут для проверки токена
 * @property {string} routeImport - маршрут для импорта
 * @property {string} routeImportRun - маршрут для запуска импорта
 * @property {string} routeAnalyticsBudget - маршрут для данных бюджета
 * @property {string} routeAnalyticsClients - маршрут для данных клиентов
 * @property {string} routeAnalyticsClientCondition - маршрут для данных клиент условия
 * @property {string} routeAnalyticsManagers - маршрут для данных менеджеров
 * @property {string} routeAnalyticsDirections - маршрут для данных направлений
 * @property {string} routeAnalyticsSupplyers - маршрут для данных операторов
 * @property {string} routeAnalyticsTotal - маршрут для общей аналитики
 * @property {string} routeAnalyticsTotalBudget - маршрут для данных текущего бюджета общей аналитики
 * @property {string} routeAnalyticsTotalClients - маршрут для данных топ клиентов
 * @property {string} routeAnalyticsTotalSupplyers - маршрут для данных топ подрядчиов
 * @property {string} routeAnalyticsTotalClientSupplyers - маршрут для топ прибыльных / убыточных подрядчиков по клиентам
 * @property {string} routeCreateSlice - маршрут для создания среза
 * @property {string} routeCopyLastSlice - маршрут для копирования данных последнего среза в текущие
 * @property {string} routeAliasesAttributes - маршрут для получения списка атрибутов алиасов
 * @property {string} routeAliasesAttributeGroups - маршрут для получения групп для выбранного атрибута алиаса
 * @property {string} routeAliasesUngroupedValues - маршрут для получения несгруппированных значений для выбранного атрибута алиаса
 * @property {string} routeAliasesRemoveGroup - маршрут для удаления группы алиаса
 * @property {string} routeAliasesAddGroup - маршрут для добавления группы алиаса
 * @property {string} routeAliasesRemoveGroupValues - маршрут для удаления значений из группы алиаса 
 * @property {string} routeAliasesCreateTask - маршрут для создания задачи на внесение изменений в базу для выбранного атрибута алиаса
 * @property {string} routeLogLinks - маршрут для получения массива ссылок на логи
 *
 * @property {string} routeClientList - список клиентов пользователя
 * @property {string} routeClientEdit - редактирование клиента
 * @property {string} routeClientAdd - добавление клиента
 * @property {string} routeClientRemove - удаление клиента
 * @property {string} routeClientManagers - список менеджеров проекта
 * @property {string} routeClientAddLinks - прикрепление пользователей к клиенту
 * @property {string} routeClientSettings - клиенты и связи проекта
 * @property {string} routeAnalyticsSummary - сводные данные
 * @property {string} routeAnalyticsSummaryDetail - детализация сводных данных по месяцам
 *
 * @property {string} routeShareList - список группхедов
 * @property {string} routeShareUpdate - обновление элемента таблицы
 */
let schemeApi = {
    urlLogin: `${host}/login`,
    urlLoginSms: `${host}/login-sms`,
    urlCheckPhone: `${host}/send-sms`,
    urlLogout: `${host}/logout`,
    urlCheckToken: `${host}/check-token`,
    
    routeImportAddTask: '/upload/add-task',
    routeImportCheckTask: '/upload/check-task',
    routeImport: '/upload/index',
    routeImportRun: '/upload/run',
    
    routeAnalyticsBudget: '/program/slice-budget',
    routeAnalyticsClients: '/program/client-slices-data',
    routeAnalyticsBrands: '/program/brand-slices-data',
    routeAnalyticsClientCondition: '/program/condition-client',
    routeAnalyticsManagers: '/program/slice-manager-data',
    routeAnalyticsDirections: '/program/slice-direction-data',
    routeAnalyticsSupplyers: '/program/condition-supplyer',
    routeAnalyticsTotal: '/program/manager-analytics-common-data',
    routeAnalyticsTotalBudget: '/program/manager-date-budget',
    routeAnalyticsTotalClients: '/program/manager-clients',
    routeAnalyticsTotalSupplyers: '/program/manager-supplyers',
    routeAnalyticsTotalClientSupplyers: '/program/manager-client-supplyers',
    routeCreateSlice: '/program/slice-create',
    routeCopyLastSlice: '/upload/slice-back',

    routeAliasesAttributes: '/property/get-attributes',
    routeAliasesAttributeGroups: '/property/get-attribute-groups',
    routeAliasesUngroupedValues: '/property/get-ungrouped-values',
    routeAliasesCatalogValues: '/property/get-catalog-values',
    routeAliasesRemoveGroup: '/property/remove-group',
    routeAliasesAddGroup: '/property/add-group',
    routeAliasesRemoveGroupValues: '/property/remove-group-values',
    routeAliasesCreateTask: 'property/create-task',
    routeCatalogSetValue: 'property/set-catalog-value',
    routeCatalogDeleteValue: 'property/delete-catalog-value',

    routeLogLinks: 'log/links',

    routeBrandList: 'client/brand-list',
    routeBrandAdd: 'client/brand-add',
    routeBrandEdit: 'client/brand-edit',

    routeSliceList: 'program/slice-list',
    routeSliceRemove: 'program/slice-remove',

    routeClientList: 'client/list',
    routeClientEdit: 'client/edit',
    routeClientAdd: 'client/add',
    routeClientRemove: 'client/remove',
    routeClientManagers: 'client/managers',
    routeClientAddLinks: 'client/add-client-links',
    routeUserClientSettings: 'client/get-user-client-settings',
    routeClientSettings: 'client/get-client-settings',
    routeClientEditYear: 'client/edit-client-year',
    routeClientRemoveYear: 'client/remove-client-year',
    routeClientGetNewYear: 'client/get-new-year-clients',

    routeShareList: 'share/list',
    routeShareUpdate: 'share/update',

    routeExportClients: 'export/clients',
    routeExportMedia: 'export/media',
    routeExportClientsDetail: 'export/clients-detail',
    routeExportPlacementsTask: 'export/placements-task',
    routeExportPlacementsTaskNew: 'export/placements-task-new',
    routeExportCheckTask: 'export/check-task',
    routeExportSupplierReport: 'export/supplier-kind',

    routeAnalyticsSummary: 'summary/get',
    routeAnalyticsSummaryDetail: 'summary/detail',

    routeHistory: 'upload/history-list',
};

export default schemeApi;